/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { DdtSubject } from '../../models/ddt-subject';

export interface DdtControllerDeleteSubject$Params {
  id: number;
}

export function ddtControllerDeleteSubject(http: HttpClient, rootUrl: string, params: DdtControllerDeleteSubject$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: DdtSubject;
}>> {
  const rb = new RequestBuilder(rootUrl, ddtControllerDeleteSubject.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: DdtSubject;
      }>;
    })
  );
}

ddtControllerDeleteSubject.PATH = '/ddt/subject/{id}';
